module.exports = __webpack_public_path__ + "static/media/bursts_04.a9fd2193.svg";